import { Application, Sprite } from "pixi.js";
import Scene from "./Scene";
import { ConfigParams } from "../GameConfig";
import CurrentJackpots from "../components/CurrentJackpots";
// import InfoMessages from "../components/InfoMessage";
import { CurrentJackpotValue } from "../models/JackpotCurValue";
import { Marquee } from "../components/Marquee";
import GlobalStore from "../services/GlobalStore";
import { MarqueeJpHistoryItem } from "../components/MarqueeJpHistoryItem";
import { CommonEvents, GameEvents, MessageEvents } from "../events/EventEnums";

type SceneCurrentJackpotProps = {
  app: Application;
  config: ConfigParams;
  name: string;
};

const STAGE = {
  width: 1920,
  height: 1080,
};

class SceneCurrentJackpot extends Scene {
  private readonly curJackpots: CurrentJackpots;
  private readonly currentValues: CurrentJackpotValue[] = [];

  private marquee: Marquee;

  constructor({ app, config, name }: SceneCurrentJackpotProps) {
    super({
      app: app,
      name: name,
      bgVideoPath: config.current_jackpot.video_path,
      bgImagePath: config.current_jackpot.image_path,
    });

    this.curJackpots = new CurrentJackpots();

    this.contentContainer.addChild(this.curJackpots);
    this.curJackpots.zIndex = this.topZ;

    // const infoMessages = new InfoMessages();
    // infoMessages.zIndex = 2;
    // this.contentContainer.addChild(infoMessages);

    // const plonk = Sprite.from(`_plonk_jackpot`);
    // this.bgContainer.addChild(plonk);
    // plonk.zIndex = 1;
    // if (this.bgImage) this.bgImage.y = 90;

    const title = Sprite.from(`jackpot-title`);
    title.anchor.set(0.5, 0.5);
    title.position.set(STAGE.width / 2 - 5, 222);

    const frame = Sprite.from(`jackpot-frame`);
    frame.anchor.set(0.5, 0.5);
    frame.position.set(STAGE.width / 2, STAGE.height / 2 + 32);

    // const historyBgUnderlay = Sprite.from(`history-additional-bg`);
    // historyBgUnderlay.anchor.set(0.5, 0);
    // historyBgUnderlay.position.set(STAGE.width / 2, STAGE.height - 225);
    const historyBg = Sprite.from(`history-background`);
    historyBg.anchor.set(0.5, 0);
    historyBg.position.set(STAGE.width / 2, STAGE.height - 225);
    const historyTitle = Sprite.from(`history-title`);
    historyTitle.anchor.set(0.5, 0.5);
    historyTitle.position.set(-5, 67);
    historyBg.addChild(historyTitle);
    // historyBg.alpha = 0;

    for (const c of [title, frame, historyBg]) {
      this.contentContainer.addChild(c);
    }

    this.marquee = new Marquee({
      width: historyBg.width,
    });
    for (const item of GlobalStore.getJackpotHistory()) {
      const historyItem: MarqueeJpHistoryItem = new MarqueeJpHistoryItem(item);
      this.marquee.addItem(historyItem);
    }
    historyBg.addChild(this.marquee);
    this.marquee.x = -historyBg.width / 2;
    this.marquee.y = 120;
    // this.marquee.y = 400;
    // this.marquee.x = 400;

    GlobalStore.gameEventEmitter.on(GameEvents.JACKPOT_HISTORY_UPDATED, () => {
      for (const item of GlobalStore.getJackpotHistory()) {
        const historyItem: MarqueeJpHistoryItem = new MarqueeJpHistoryItem(
          item,
        );
        this.marquee.addItem(historyItem);
      }
    });
  }

  show(): void {
    super.show();

    this.curJackpots.show();
    // this.curJackpots.hide(10);
  }

  hide(): void {
    super.hide();

    this.curJackpots.hideInstant();
  }

  public updateValues(curJps: CurrentJackpotValue[]): void {
    for (const incoming of curJps) {
      const idx = this.currentValues.findIndex((v) => v.code === incoming.code);
      if (idx >= 0) {
        this.currentValues[idx].value = incoming.value;
      } else {
        this.currentValues.push({ ...incoming });
      }
    }

    // console.log(
    //   "[SceneCurrentJackpot] Update called. New values:",
    //   this.currentValues,
    // );
    this.curJackpots.updateValues(this.currentValues);
  }
}

export default SceneCurrentJackpot;
